var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer" },
    [
      _c(
        "el-button",
        {
          staticStyle: { "margin-right": "24px", "margin-left": "16px" },
          attrs: { size: "small", type: "primary" },
          on: {
            click: function($event) {
              return _vm.submitQuery()
            }
          }
        },
        [_vm._v("确定")]
      ),
      _c("el-button", { on: { click: _vm.cancelHandle } }, [_vm._v("取消")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }